import React from 'react';
import PropTypes from 'prop-types';
import TickGreenIcon from "../Icon/TickGreen";
import SnowflakeIcon from "../Icon/Snowflake";
import BlockIcon from "../Icon/Block";
import PowerButtonGreenIcon from "../Icon/PowerButtonGreen";
import PowerButtonBlueIcon from "../Icon/PowerButtonBlue";
import TickBlueIcon from "../Icon/TickBlue";
import classNames from 'classnames';
import { observer, inject } from 'mobx-react';

const ExpertStatusIcon = ({
  expertStatusId,
  staticData,
  expertView,
  expertSearch,
  eplView
}) => {
  let iconComponent = null;
  const {
    EXPERT_STATUSES
  } = staticData.CONST;
  const classes = classNames({
    'expert-status-icon': true,
    'expert-status-icon__vertical-align': expertView,
    'expert-status-icon__expert-search': expertSearch,
    'expert-status-icon__epl-view': eplView
  });

  switch (expertStatusId) {
    case EXPERT_STATUSES.DO_NOT_CONTACT:
      iconComponent = /*#__PURE__*/React.createElement(BlockIcon, {
        noClick: true
      });
      break;

    case EXPERT_STATUSES.COLD_PROSPECT:
      iconComponent = /*#__PURE__*/React.createElement(SnowflakeIcon, {
        noClick: true
      });
      break;

    case EXPERT_STATUSES.WARM_PROSPECT:
      iconComponent = /*#__PURE__*/React.createElement(TickBlueIcon, {
        noClick: true
      });
      break;

    case EXPERT_STATUSES.DORMANT_PROSPECT:
      iconComponent = /*#__PURE__*/React.createElement(PowerButtonBlueIcon, {
        noClick: true
      });
      break;

    case EXPERT_STATUSES.ACTIVE_EXPERT:
      iconComponent = /*#__PURE__*/React.createElement(TickGreenIcon, {
        noClick: true
      });
      break;

    case EXPERT_STATUSES.DORMANT_EXPERT:
      iconComponent = /*#__PURE__*/React.createElement(PowerButtonGreenIcon, {
        noClick: true
      });
      break;

    default:
      break;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, iconComponent);
};

ExpertStatusIcon.propTypes = {
  expertStatusId: PropTypes.number.isRequired,
  staticData: PropTypes.object.isRequired,
  expertView: PropTypes.bool,
  expertSearch: PropTypes.bool,
  eplView: PropTypes.bool
};
export default inject('staticData')(observer(ExpertStatusIcon));